import { Box, Grid, Modal, Step, StepLabel, Stepper } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import React, { FormEvent, useEffect, useState } from 'react'
import { forkJoin } from 'rxjs'
import { getFileContainer } from '../../container/file-module'
import { FILE_SERVICE_KEY } from '../../modules/files'
import { FileService } from '../../modules/files/services/FileService'
import { FormAction, FormActions } from '../../common/utils/form-generation'
import { commonStyles } from '../../common/styles/Styles'
import { FirstStep } from './FirstStep'
import { SecondStep } from './SecondStep'
import { ThirdStep } from './ThirdStep'
import { IGV } from './IGV'
import { ProjectAnalysis } from 'modules/projects/models/Project'
import { useLocation } from '@reach/router'
import { URL_PGD_TEST } from 'routes/routes-constants'
import {FourthStep} from "./FourthStep";
import { Results } from './Results'
import { Individual } from 'modules/individuals/models/Individual'
import { Embryo } from 'modules/embryos/models/Embryo'
import { getClinicContainer } from 'container/clinic-modules'
import { ClinicService } from 'modules/clinics/services/ClinicService'
import { CLINIC_SERVICE_KEY } from 'modules/clinics'
import { getPatientContainer } from 'container/patient-module'
import { PatientService } from 'modules/patients/services/PatientService'
import { PATIENT_SERVICE_KEY } from 'modules/patients'
import { MutationsPosition } from 'modules/mutationsPosition/models/MutationsPosition'

const steps = ['projects', 'informativeness', 'PGT-M', 'results']

export type FileType = {
  id: string
  name: string
}

export type InformativeSNP = {
  upstream: number,
  intrangenic: number,
  downstream: number
}

const fileService = getFileContainer().get<FileService>(FILE_SERVICE_KEY)
const clinicServic = getClinicContainer().get<ClinicService>(CLINIC_SERVICE_KEY)
const patientService = getPatientContainer().get<PatientService>(PATIENT_SERVICE_KEY)

type FormProps = {
  onResultsModeChange?: (isResults: boolean) => void
}

export const Form = (props: FormProps) => {
  const styles = commonStyles()
  const { t } = useTranslation()
  const [currentStep, setCurrentStep] = useState<number>(0)
  const [fileTypes, setFileTypes] = useState<FileType[]>([])
  const [open, setOpen] = useState<boolean>(false)
  const increaseStep = () => setCurrentStep(currentStep + 1)
  const decreaseStep = () => setCurrentStep(currentStep - 1)
  const [project, setProject] = useState<ProjectAnalysis>()
  const [patientInfo, ] = useState<InformativeSNP>()
  const [partnerInfo, ] = useState<InformativeSNP>()
  const location = useLocation()
  const [dataProject, setData] = useState<any>()
  const [viewResult, setIsViewResult] = useState<boolean>(false)
  const [individuals, setIndividuals] = useState<Individual[]>([])
  const [embryos, setEmbryos] = useState<Embryo[]>([])
  const [header, setHeader] = useState<string>('')
  const [signature, setSignature] = useState<string>('')
  const [roleSignature, setRoleSignature] = useState<string>('')
  const [signedBy, setSignedBy] = useState<string>('')
  const [seeSex, setSeeSex] = useState<boolean>(false)
  const [viewIGV, setViewIGV] = useState<boolean>(false)
  const [variants, setVariants] = useState<MutationsPosition[]>([])
  const [fromIndi, setFromIndi] = useState<boolean>(false)
  const [fromEmb, setFromEmb] = useState<boolean>(false)


  useEffect(()=> {
    if (location.pathname === URL_PGD_TEST) {
      setCurrentStep(0)
      setIsViewResult(false)
      setViewIGV(false)

    }
  }, [location])

  useEffect(() => {
    props.onResultsModeChange && props.onResultsModeChange(viewResult)
  }, [viewResult])

    useEffect(() =>  {
      if (project) {
        patientService.getByID(project?.patientID || '').subscribe(patientRes => {
          patientRes && clinicServic.getByID(patientRes.clinicID).subscribe(clinicRes =>{
            setHeader(clinicRes?.header || '')
            setSignature(clinicRes?.signature || '')
            setRoleSignature(clinicRes?.roleSignature || '')
            setSignedBy(clinicRes?.signedBy || '')
            setSeeSex(clinicRes?.seeSex || false)

          })
      })
      }
      
    }, [project])

  const deleteFiles = (e: FormEvent) => {
    e.preventDefault()
    forkJoin(fileTypes.map((f) => fileService.delete(f.id))).subscribe(() => {
      setOpen(false)
      setCurrentStep(0)
    })
  }

  const actionsDelete: FormAction[] = [
    {
      label: t('close'),
      handleAction: () => setOpen(false),
    },
  ]

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} style={viewResult ? { position: 'sticky', top: 136, zIndex: 55, background: 'white' } : undefined}>
        <Stepper activeStep={currentStep}>
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel>{t(label)}</StepLabel>
            </Step>
          ))}
        </Stepper>
      </Grid>

      {currentStep === 0  && !viewIGV && !viewResult && (
        <FirstStep
          increaseStep={increaseStep}
          files={setFileTypes}
          handleSelectProject={setProject}
          project={project}
        />
      )}

      {currentStep === 1  &&!viewIGV && !viewResult && (
        <SecondStep
          increaseStep={increaseStep}
          decreaseStep={decreaseStep}
          setData={setData}
          setIsViewResult={setIsViewResult}
          deleteFiles={() => setOpen(true)}
          project={project}
          setProject={setProject}
          currentStep={currentStep}
          setIndividuals = {setIndividuals}
          setViewIGV = {setViewIGV}
          setVariants = {setVariants}
        />
      )}

      {currentStep === 2 &&!viewIGV && !viewResult && (
        <ThirdStep
          increaseStep={increaseStep}
          decreaseStep={decreaseStep}
          setData={setData}
          setIsViewResult={setIsViewResult}
          deleteFiles={() => setOpen(true)}
          project={project}
          setProject={setProject}
          currentStep={currentStep}
          setEmbryos = {setEmbryos}
          setViewIGV = {setViewIGV}
          setVariants = {setVariants}
          seeSex= {seeSex}
          embryos={embryos}
        />
      )}

      {currentStep === 3 && !viewIGV && !viewResult&& (
        <FourthStep 
          increaseStep={increaseStep} 
          project={project}
          setCurrentStep={setCurrentStep} 
          deleteFiles={() => setOpen(true)}          
          patientInfo={patientInfo}
          partnerInfo={partnerInfo}           
          headerID={header}
          signatureID={signature}
          roleSigne={roleSignature}
          signedBy={signedBy}
          seeSex= {seeSex}
          setFromIndi= {setFromIndi}
          setFromEmb= {setFromEmb}
          fromIndi={fromIndi}
          fromEmb={fromEmb}
          />

      )}

      {viewResult && (
        <Results
          data={dataProject}
          project={project}
          return={setIsViewResult}
          setProject={setProject}
          currentStep={currentStep}
          individuals={individuals}
          embryos={embryos}
          setCurrentStep={setCurrentStep}
          setIndividuals = {setIndividuals}
          setEmbryos = {setEmbryos}
          setViewResult = {setIsViewResult}
          seeSex= {seeSex}
          setFromIndi= {setFromIndi}
          setFromEmb= {setFromEmb}
        />
      )}
      
      { viewIGV && (
          <IGV project={project} individuals={individuals} variants={variants} embryos={embryos} setViewIGV={setViewIGV} step={currentStep}/>
      )}
      <Modal open={open}>
        <Box className={styles.modal}>
          <form onSubmit={deleteFiles}>
            <Box mt={2} textAlign={'justify'}>
              {t('cancelReceptiveness')}
            </Box>
            <FormActions actions={actionsDelete} message={t('confirm')} />
          </form>
        </Box>
      </Modal>
    </Grid>
  )
}
